import React from 'react';
import { WebsiteDesignProps } from './types';
import { Leaf, Droplets, Sun } from 'lucide-react';
import { Button } from "@/components/ui/button";

const TropicalJungle: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Rainforest Academy";

    return (
        <div className="bg-[#0f3d0f] text-[#e8f5e9] min-h-screen font-sans overflow-hidden relative">
            {/* Background Image */}
            <div className="absolute inset-0 z-0">
                <img src="https://images.unsplash.com/photo-1549220973-456cb3c67530?q=80&w=2069&auto=format&fit=crop" className="w-full h-full object-cover opacity-40 hover:scale-105 transition-transform duration-[20s]" alt="Jungle" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f3d0f] via-[#0f3d0f]/80 to-transparent"></div>
            </div>

            <nav className="relative z-20 p-8 flex justify-between items-center bg-gradient-to-b from-black/50 to-transparent">
                <div className="text-3xl font-black text-[#ffbd4a] tracking-tight drop-shadow-md">
                    {schoolName}
                </div>
                <Button className="bg-[#ffbd4a] text-[#0f3d0f] hover:bg-[#ffca28] rounded-full font-bold px-8 shadow-lg">
                    Wild Admissions
                </Button>
            </nav>

            <main className="relative z-10 container mx-auto px-8 py-20 flex flex-col items-start">
                <div className="bg-[#0f3d0f]/60 backdrop-blur-md p-12 rounded-3xl border border-[#4caf50]/30 max-w-2xl">
                     <h1 className="text-6xl md:text-8xl font-bold mb-6 leading-none text-[#a5d6a7]">
                         Grow <br/> Wild.
                     </h1>
                     <p className="text-xl text-gray-200 mb-8 font-medium">
                         An ecosystem of learning set in the heart of nature. Discover your instincts.
                     </p>
                     <div className="flex gap-4">
                         <Button variant="ghost" className="text-[#ffbd4a] border border-[#ffbd4a] hover:bg-[#ffbd4a] hover:text-[#0f3d0f] rounded-full px-8">
                             Watch Video
                         </Button>
                     </div>
                </div>

                <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
                    <div className="bg-[#e8f5e9] text-[#0f3d0f] p-8 rounded-2xl shadow-xl hover:-translate-y-2 transition-transform">
                        <Leaf className="w-12 h-12 text-[#2e7d32] mb-4" />
                        <h3 className="text-2xl font-bold mb-2">Botany</h3>
                        <p className="opacity-80">Plant sciences and agriculture focus.</p>
                    </div>
                    <div className="bg-[#e8f5e9] text-[#0f3d0f] p-8 rounded-2xl shadow-xl hover:-translate-y-2 transition-transform translate-y-8 md:translate-y-12">
                        <Droplets className="w-12 h-12 text-[#0277bd] mb-4" />
                        <h3 className="text-2xl font-bold mb-2">Ecology</h3>
                        <p className="opacity-80">Understanding water and life systems.</p>
                    </div>
                    <div className="bg-[#e8f5e9] text-[#0f3d0f] p-8 rounded-2xl shadow-xl hover:-translate-y-2 transition-transform">
                        <Sun className="w-12 h-12 text-[#f9a825] mb-4" />
                        <h3 className="text-2xl font-bold mb-2">Energy</h3>
                        <p className="opacity-80">Solar power and sustainable living.</p>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default TropicalJungle;
